/**
 * On Range Wedge Play Reducers
 */
import {
    ORTWEDGEPLAY_ACTION,
    ALL_ORTWEDGEPLAY,
    ADD_ORTWEDGEPLAY,
    FETCH_ORTWEDGEPLAY,
    EDIT_ORTWEDGEPLAY,
    DELETE_ORTWEDGEPLAY,
    FETCH_ORTWEDGECHART,
    FETCH_ORTWEDGESHOTCHART,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    ortwedgeplaylist:[],
    particularortwedgeplay:[],   
    ortwedgechart:[],
    ortwedgeshotchart:[], 
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case ORTWEDGEPLAY_ACTION:
            return { ...state, loading: true };       

        case ALL_ORTWEDGEPLAY:
            return { ...state, loading: false, ortwedgeplaylist: action.payload };     
            
        case ADD_ORTWEDGEPLAY:
            return { ...state, loading: false };     
         
        case FETCH_ORTWEDGEPLAY:
            return { ...state, loading: false, particularortwedgeplay: action.payload };  
            
        case EDIT_ORTWEDGEPLAY:
            return { ...state, loading: false }; 
            
        case DELETE_ORTWEDGEPLAY:
            return { ...state, loading: false };          
        
        case FETCH_ORTWEDGECHART:
            return { ...state, loading: false, ortwedgechart: action.payload }; 

        case FETCH_ORTWEDGESHOTCHART:
            return { ...state, loading: false, ortwedgeshotchart: action.payload }; 

        default: return { ...state };

     }
 }